module.exports = __webpack_public_path__ + "static/Bantu_Market_city_toggle-f7ab59fcc7f5f422ec03795d9174fe23.png";